export default "__VITE_ASSET__Di6omiJ6__"